import { FC, PropsWithChildren, memo } from 'react'

import styled from 'styled-components'

const Box = styled.div<{ isFullWidth: boolean }>`
  width: ${({ isFullWidth }) => (isFullWidth ? '226px' : '160px')};
`

export const FilterItemWrapper: FC<PropsWithChildren<{ isFullWidth?: boolean }>> = memo(
  ({ children, isFullWidth = true }) => {
    return <Box isFullWidth={isFullWidth}>{children}</Box>
  }
)
